import { z } from 'zod';
import { UserSchema } from 'types/users';
import { TeamSchema } from 'types/teams';
import { ProductSchema } from 'types/products';
import { GoalSchema } from 'types/goals';
import { GameIdSchema, GameSchema } from 'types/games';
import { AccountSchema } from 'types/accounts';
import { NotificationSchema } from 'types/notifications';
import { NumericalIdSchema } from 'types/commonTypes';
import { ActivitySchema } from 'types/activity';
// App settings from backend
var AppSettingsSchema = z.object({
    sbb_api_endpoint: z.string().optional(),
    sbb_pusher_key: z.string(),
    sbb_socket_server: z.string().optional(),
    posthog_key: z.string().optional(),
    posthog_host: z.string().optional()
}).passthrough(); // Allow additional properties we don't need to type
export var CompanyDataSchema = z.object({
    account: AccountSchema,
    activities: z.array(ActivitySchema),
    app_settings: AppSettingsSchema.optional(),
    current_user: UserSchema.partial(),
    daily_activity: z.record(z.string(), z.number()),
    games: z.array(GameSchema).optional(),
    games_list: z.object({
        owned: z.union([z.record(z.string(), z.string()), z.array(GameIdSchema)]),
        guest: z.union([z.record(z.string(), z.string()), z.array(GameIdSchema)]),
        all: z.array(GameIdSchema)
    }),
    goals: z.array(GoalSchema),
    notifications: z.array(NotificationSchema),
    orderings: z.array(z.object({
        id: z.number(),
        order: z.number(),
        product_id: z.number().nullable()
    }).passthrough()),
    // SCO-818: PHP puts the app settings at the TOP LEVEL of the data mobile
    // and Fire TV fetch (and of the sign-in answer), not under app_settings.
    // Declared so the sign-in path's parse does not strip what the feature-flag
    // request needs (utils/FeatureFlags flagSettingsFrom). Not read by analytics.
    // `.catch(undefined)`: a value that is not a string is dropped, as it was
    // when these were undeclared; it must never fail the sign-in parse.
    posthog_key: z.string().optional().catch(undefined),
    posthog_host: z.string().optional().catch(undefined),
    sbb_api_endpoint: z.string().optional().catch(undefined),
    periods: z.array(z.object({
        id: z.number().optional(),
        start_hour: z.number().optional(),
        start_minute: z.number().optional(),
        end_hour: z.number().optional(),
        end_minute: z.number().optional()
    })),
    products: z.array(ProductSchema),
    sbb_pusher_key: z.string().optional(),
    sbb_socket_server: z.string().optional(),
    teams: z.array(TeamSchema),
    timezones: z.array(z.object({
        timezone: z.string(),
        offset: z.string(),
        name: z.string()
    })),
    users: z.array(UserSchema),
    version: NumericalIdSchema.optional(),
    global_loader: z.boolean().optional()
});
export var GameWithDetailsSchema = GameSchema.extend({
    player_details: z.array(UserSchema),
    team_details: z.array(TeamSchema)
});
